export const shouldShowLegacyScannerControls = (
  value = process.env.REACT_APP_SHOW_LEGACY_SCANNER_CONTROLS
): boolean => value === "true";
